import { render, staticRenderFns } from "./notiModal.vue?vue&type=template&id=2a2f80f0&scoped=true"
import script from "./notiModal.vue?vue&type=script&lang=js"
export * from "./notiModal.vue?vue&type=script&lang=js"
import style0 from "./notiModal.vue?vue&type=style&index=0&id=2a2f80f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f80f0",
  null
  
)

export default component.exports